var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadgeImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 15,
    viewBox: "0 0 13 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.52173 0.166748L0.521729 2.83341V6.83342C0.521729 10.5334 3.08173 13.9934 6.52173 14.8334C9.96173 13.9934 12.5217 10.5334 12.5217 6.83342V2.83341L6.52173 0.166748ZM8.57506 10.1667L6.52173 8.93341L4.47506 10.1667L5.01506 7.83342L3.2084 6.27341L5.59506 6.06675L6.52173 3.86675L7.4484 6.06008L9.83506 6.26675L8.0284 7.83342L8.57506 10.1667Z",
    fill: "#6D6D6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeImage);
export default __webpack_public_path__ + "static/media/BadgeImage.a087a8219ce71b74309394aec5f9d774.svg";
export { ForwardRef as ReactComponent };